// Summary tiles for the Smart Assist metrics page (slice 1).
// Title and help-text strings live in
// `public/locales/en/translation.json` under
// `metrics_tab.smart_assist_tab.overview_tab.tiles.<key>.{title,help_text}` —
// resolved at render time in Overview.vue. `category` drives formatting in
// SmartAssistTile.vue: 'count' | 'percent' | 'ratio'
export const SMART_ASSIST_TILES = [
  { key: 'queries', category: 'count', highlight: true },
  { key: 'answer_rate', category: 'percent', highlight: true },
  { key: 'feedback', category: 'percent' },
  { key: 'users', category: 'count' },
  { key: 'feedback_rate', category: 'percent' },
  { key: 'sessions', category: 'count' },
  { key: 'queries_per_session', category: 'ratio' },
];
